<template>
	<div class="m_container" :style="openType == 'mob' ? 'background:#fff' : ''"
		:class="openType != 'mob' ? 'flex_center flex_items vh100' : ''">
		<div class="content page_bg" style="box-sizing: border-box; padding-bottom: 80px;"
			:class="openType != 'mob' ? 'container_w_h' : 'vh100 w100'"
			:style="openType == 'mob' ? 'padding-top:160px' : 'padding-top:'+pcPt+'px'">
			<div class="pt20 page_bg" id="top" :class="openType != 'mob' ? 'ser-top':''">
				<div class="flex_items flex flex_center page_bg w100 top">
					<div class="txt_center" :class="handleClick == 0 ? 'main_bg cf' : ''" @click="clickFn(0)">管控</div>
					<div class="txt_center ml20" :class="handleClick == 1 ? 'main_bg cf' : ''" @click="clickFn(1)">工作人员
					</div>
					<div class="txt_center ml20" :class="handleClick == 2 ? 'main_bg cf' : ''" @click="clickFn(2)">会员
					</div>
				</div>
				<div class="w100 bgfff flex flex_items plr20 flex_center mt20" style="height: 60px;box-sizing: border-box;">
					搜索姓名 <input type="text" class="ml20 plr10" placeholder="请输入搜索姓名" @input="serChange"
						v-model="username" style="height: 30px;" />
				</div>
			</div>
			<div class="bgfff plr20">
				<!-- @click="$router.push({ path: '/addAccount', query: { id: item.id } })" -->
				<div class="flex  pt20 pb20 bor_b flex_between flex_items"
					v-for="(item, index) in list" :key="index"
					@click="$router.push({ path: '/userdetail', query: { id: item.id } })">
					<div class="flex flex_items">
						<div class="text_overflow" style="width: 110px;">{{item.name}}</div>
						<div class="">{{item.phone}}</div>
					</div>
					<!-- <div class="flex">
						<van-icon @click.stop="del(item)" name="delete-o" size="30" color="red" class="mr10" />
						<van-icon @click.stop="re(item)" name="revoke" size="30" />
					</div> -->
				</div>
				<div class="empty" v-if="list.length == 0">
					暂无数据
				</div>
			</div>
			<div class="btn-box">
				<a href="/h5/temaplte/account.xlsx" download="账号导入模板.xlsx">
					<div class="upload main_bg cf">
						模板 <br>下载
					</div>
				</a>
				<div class="upload main_bg cf pos">
					<input type="file" class="inp" id="file" @change="upload($event)">
					导入
				</div>
			</div>
		</div>
		<div class="bottom_btn" @click="$router.push('/addAccount')">
			<div class="btn_contenbt">
				新增账号
			</div>
		</div>
		
	</div>
</template>

<script>
	import {
		openType,
		pcContentHeight
	} from '@/utils/tool.js'
	import {
		Popup,Dialog
	} from "vant";
	export default ({
		components: {
			Popup
		},
		data() {
			return {
				handleClick: 0,
				list: [],
				openType: openType(),
				id: '',
				allList: [],
				username: '',
				serList: [], //按照role搜索的列表
				pcPt: 160,
				show: false,
				reMsg: {},
				password: '',
				repassword: ''
			}
		},
		methods: {
			clickFn(t) {
				this.handleClick = t;
				this.username = ''
				this.list = [];
				let o = t == 0 ? '0' : t == 1 ? 'officer' : 'member'
				this.handleData(o)
			},
			getList(t) {
				this.api
					.accountList()
					.then((res) => {
						this.allList = res.data;
						this.handleData(t)
					});
			},
			upload(files){
				// console.log(files.target.files);
				
				if (files) {
					let file = files.target.files[0];
					const fromData = new FormData()
					fromData.append('file', file)
					// fromData.append('api_token', this.api_token)
					this.api.accountImport(fromData).then(r => {
						if (r.code == 0) {
							// this.$emit('uploadFile', r.data)
							// console.log(r.message);
							if(r.message){
								this.Toast(r.message);
							}
							this.getList('0');
						}else{
							this.Toast(r.message);
						}
					})
					var obj = document.getElementById('file'); 
					obj.value = '';
				}
				
			},
			serChange() {
				// console.log(this.username)
				if (this.username == '') {
					this.list = JSON.parse(JSON.stringify(this.serList));
					return
				}
				let l = JSON.parse(JSON.stringify(this.serList));
				let arr = []
				l.map(r => {
					if (r.name.indexOf(this.username) >= 0) {
						arr.push(r)
					}
				})
				this.list = arr
			},
			handleData(t) {
				let roleStr = [t]
				if (t == 0) {
					roleStr = ['admin', 'manager']
				}
				let arr = [];
				this.allList.map(r => {
					if (roleStr.indexOf(r.role) >= 0) {
						arr.push(r)
					}
				})
				this.list = JSON.parse(JSON.stringify(arr));
				this.serList = JSON.parse(JSON.stringify(arr));
			},
			
			
			
		},
		created() {
			this.openType = openType()
			this.handleClick = 0
			this.getList('0');
			if (this.openType != 'mob') {
				this.$nextTick(() => {
					this.pcPt = pcContentHeight('top');
				})
			}
		}
	})
</script>

<style scoped="scoped">
	#top {
		height: 160px;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		box-sizing: border-box;
		z-index: 2;
		box-sizing: border-box;
	}

	#top.ser-top {
		width: 390px;
		left: 50%;
		transform: translateX(-50%);
	}

	.top>div {
		width: 85px;
		height: 40px;
		line-height: 40px;
		border-radius: 10px;
	}

	.content {
		/* padding-top: 80px; */
		overflow-y: auto;
	}

	.name {
		width: 100px;
	}

	.btn-box{
		position: fixed;
		bottom: 100px;
		right: 10px;
	}
	.container_w_h .btn-box{
		right: calc( 50vw - 180px);
		bottom: 150px;
	}
	.upload{
		width: 50px;
		height: 50px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		font-size: 15px;
		margin-top: 10px;
	}


	.inp{
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
	}

	
</style>
